/* EcommerceFilters — Iter 110/Faz4: search + chip filter satırı.
 * BulkBar artık ayrı (sticky bottom). */
import React from 'react';

export default function EcommerceFilters({
    search, onSearchChange,
    onlyPending, onTogglePending,
}) {
    return (
        <div className="bg-white border border-gray-200 rounded-xl p-3 flex flex-wrap items-center gap-3">
            <div className="flex items-center gap-2 flex-1 min-w-[260px]">
                <input
                    type="text"
                    value={search}
                    onChange={(e) => onSearchChange(e.target.value)}
                    placeholder="Ara: sipariş no, müşteri, e-posta, ürün, EAN, VAT..."
                    className="flex-1 h-9 px-3 text-sm border border-gray-300 rounded-md focus:ring-1 focus:ring-gray-900 focus:border-gray-900"
                    data-testid="bol-search-input"
                />
            </div>
            <button
                onClick={onTogglePending}
                className={`h-8 px-3 text-xs font-semibold rounded-full border transition-colors ${onlyPending
                    ? 'bg-amber-100 border-amber-300 text-amber-800'
                    : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'}`}
                data-testid="filter-pending-only">
                Billit&apos;e Gönderilmemiş
            </button>
        </div>
    );
}
